import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useAxios } from '../context/AxiosContext';

interface IJobsPagination {
  limit?: number;
  skip?: number;
  template?: string;
  date?: { [d: string]: Date };
  status?: string;
  sortBy: { id: string; desc?: boolean }[];
}

export function useResellerJobsList(params: IJobsPagination) {
  const { authAxios } = useAxios();

  const fetchResellerJobs = useCallback(
    async ({ limit, sortBy, ...params }: IJobsPagination) => {
      const response = await authAxios.get<any>('/reseller/jobs-data', {
        params: {
          ...params,
          sort: sortBy.map(({ id, desc }) => ({ [id || 'CreatedAt']: desc ? 1 : -1 }))[0],
          limit: limit && limit >= 1 ? limit : 1
        }
      });
      return response.data;
    },
    [authAxios]
  );

  return useQuery(['reseller-jobs', params], () => fetchResellerJobs(params), {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !!(!params.date || (params.date.from && params.date.to)),
    refetchInterval: 15000
  });
}
